<template>
    <div class="image-viewer">
        <img :src="source" :alt="effectiveAlt" style="cursor: pointer;" @click="showingModal = true"/>
        <b-modal v-model="showingModal" :title="$i18n.gt('TEXTSECTIONS_IMAGE_FIELD')" size="lg" modal-class="image-viewer-modal">
            <img :src="source" :alt="effectiveAlt"/>
            <template v-slot:modal-footer>
                <b-btn size="sm" variant="secondary" :href="source" target="_blank" rel="noopener noreferrer" :aria-label="$i18n.gt('DOWNLOAD_IMAGE_LABEL') + ' (' + $i18n.gt('EXTERNAL_LINK_LABEL') + ')'">
                    <b-icon-download aria-hidden="true"/>
                </b-btn>
            </template>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'ImageViewer',
    props: {
        source: String,
        alt: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            showingModal: false,
        }
    },
    computed: {
        effectiveAlt() {
            if (this.alt !== null) return this.alt
            if (!this.source) return ''
            try {
                const decoded = decodeURIComponent(this.source)
                const filename = decoded.split('/').pop().split('?')[0]
                return filename.replace(/\.[^/.]+$/, '')
            } catch (e) {
                return ''
            }
        }
    },
}
</script>

<style lang="scss">
.image-viewer-modal {
    .modal-header .close {
        background: #eee;
        border: solid 4px #ccc;
        padding:.5rem .75rem;
    }
}
</style>
